import React, { useEffect, useState } from 'react';
import { Box, Dialog, DialogTitle, DialogContent, IconButton, Typography } from '@mui/material';
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot } from '@mui/lab';
import CloseIcon from '@mui/icons-material/Close';


export default function EvolutionTimelineModal({ open, onClose, procedure }) {
   
    const [evolutions, setEvolutions] = useState('');
    
    useEffect(() => {
        setEvolutions(procedure?.evolucoes)
    }, [procedure]);
    
    return (
        <Dialog open={open} onClose={onClose} slotProps={{ paper: { sx: { width: '1000px', maxWidth: '900px', minHeight: '500px' }, }, }} >
            <DialogTitle>
                <Typography sx={{ fontWeight: 'bold' }}>
                    Evoluções do Procedimento
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{ position: 'absolute', right: 8, top: 8, }} >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                {evolutions && evolutions.length > 0 ? (
                    <Timeline sx={{ mt: 2, [`& .MuiTimelineItem-root::before`]: { flex: 0, padding: 0 } }}>
                        {evolutions.map((evo, index) => (
                            <TimelineItem key={evo.id}>
                                <TimelineSeparator>
                                    <TimelineDot color="primary" variant='outlined' />
                                    {index < evolutions.length - 1 && <TimelineConnector />}
                                </TimelineSeparator>
                                <TimelineContent sx={{ py: '12px', px: 2 }}>
                                    <Typography variant="body1" component="div" sx={{ fontWeight: 'bold' }}>
                                        {evo.data}
                                    </Typography>
                                    <Typography sx={{ mt: 1, mb: 1.5 }} color="text.secondary">
                                        {evo.descricao}
                                    </Typography>
                                </TimelineContent>
                            </TimelineItem>
                        ))}
                    </Timeline>
                ) : (
                    <Box sx={{ p: 3, textAlign: 'center' }}>
                        <Typography color="text.secondary">
                            Nenhuma evolução registrada para este procedimento.
                        </Typography>
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    );
}